import React from 'react'

const SideBarItem = (props) => {


    return (
        <>
            <div onClick={props.handler} className="text-dark text-decoration-none c-pointer p-2 my-2 row">
                <div className="col-10">
                    { props.img ? <img src={props.icon} className='pe-3' alt='icon' /> : <i className={"ri-"+props.icon+"-line ri-lg pe-3"}></i> }
                    {props.name}
                </div>
                <div className="col-2">
                    <i className={props.active ? "ri-arrow-up-s-line ri-xl ps-2 d-inline-block rotate rotated" : "ri-arrow-up-s-line ri-xl ps-2 d-inline-block dropdown-arrow"}></i>
                </div>
            </div>
        </>
    )
}

export default SideBarItem
